<script setup lang="ts">
import { computed, watch } from 'vue'
import { useBandStore } from '../../stores/bandStore'
import { useSongStore } from '../../stores/songStore'

const bandStore = useBandStore()
const songStore = useSongStore()

const bands = computed(() => bandStore.bands)
const currentBand = computed({
  get: () => bandStore.currentBand,
  set: (val) => bandStore.setCurrentBand(val)
})

// Refresh songs when band changes
watch(() => bandStore.currentBand?.id, (newId, oldId) => {
  if (newId && newId !== oldId) {
    songStore.fetchBandSongs(newId)
  } else if (!newId) {
    songStore.clear()
  }
})

defineEmits(['create-band'])
</script>

<template>
  <div class="mb-6">
    <div class="flex items-center justify-between mb-2">
      <label class="rd-label">Your Band</label>
      <Button label="New Band" icon="pi pi-plus" text size="small" @click="$emit('create-band')" />
    </div>
    
    <div v-if="bands.length > 0 && !bandStore.initialLoading">
      <Select v-model="currentBand" :options="bands" optionLabel="name" placeholder="Select a Band" class="w-full" />
    </div>
    <div v-else-if="bandStore.initialLoading" class="h-12 bg-slate-100 animate-pulse rounded-lg"></div>
    <div v-else class="p-6 border-2 border-dashed border-slate-200 rounded-xl text-center">
      <p class="text-sm text-slate-500 mb-3">You're not in any bands yet.</p>
      <Button label="Create Your First Band" severity="primary" size="small" @click="$emit('create-band')" />
    </div>
  </div>
</template>
